<template>
  <div class="job-list-table">

    <table border="0" rules="none" v-if="body.length > 0">
      <tr class="header">
        <th v-bind:key="index" v-for="(head, index) in headList">
          {{ head.text }}
        </th>
      </tr>

      <tbody class="body">
        <tr v-bind:key="index" v-for="(body, index) in bodyList"
          :class="{'cursor-pointer': body.id}"
        >
          <td v-if="body.jobTitle" @click="onCellClick(body.id)">{{ body.jobTitle }}</td>
          <td v-if="body.company" @click="onCellClick(body.id)">{{ body.company }}</td>
          <td v-if="body.fullName" @click="onCellClick(body.id)">{{ body.fullName }}</td>
          <td v-if="body.location" @click="onCellClick(body.id)">{{ body.location }}</td>
          <td v-if="body.employmentType" @click="onCellClick(body.id)">{{ body.employmentType }}</td>
          <td v-if="body.email" @click="onCellClick(body.id)">
            <span class="lower-case-class">{{ body.email }}</span>
          </td>
          <td v-if="body.contactPerson" @click="onCellClick(body.id)">{{ body.contactPerson }}</td>
          <td v-if="body.phone" @click="onCellClick(body.id)">{{ body.phone }}</td>
          <td v-if="body.totalJobs" @click="onCellClick(body.id)">{{ body.totalJobs }}</td>
          <td v-if="body.numberOfApplications" @click="onCellClick(body.id)">{{ body.numberOfApplications }}</td>
          <td v-if="body.address" @click="onCellClick(body.id)">{{ body.address }}</td>

          <td
            class="addGreen"
            v-if="body.status === 'Active' ||
            body.status === 'hired'"
            @click="onCellClick(body.id)"
          >
            {{ body.status }}
          </td>

          <td
            class="addRed"
            v-if="body.status === 'Expired' ||
            body.status === 'declined'"
            @click="onCellClick(body.id)"
          >
            {{ body.status }}
          </td>

          <td
            class="addBlue"
            v-if="body.status === 'in-review' ||
            body.status === 'scheduled-for-interview'"
            @click="onCellClick(body.id)"
          >
            {{ body.status }}
          </td>

          <td class="addYellow" v-if="body.status === 'shortlisted'" @click="onCellClick(body.id)">
            {{ body.status }}
          </td>

          <td v-if="body.deadline" @click="onCellClick(body.id)">{{ body.deadline }}</td>
          <td v-if="body.dateApplied" @click="onCellClick(body.id)">{{ body.dateApplied }}</td>

          <td
            v-if="body.id"
            id="user-options"
          >
            <button v-on:click="openMenuOptions(body.id)" class="image-container">
              <img :src="body.threeDotsIcon" alt="menu icon" />
            </button>

            <div class="options-button-container">
              <div class="options-menu" v-if="showOptions === body.id">

                <!-- View Action -->
                <div class="options-menu-item"
                  @click="$emit('viewHandler', body.id)"
                >
                  <img class="dark" src="../../assets/images/view-dark.svg" alt="view icon" />
                  <img class="light" src="../../assets/images/view-light.svg" alt="view icon" />
                  <div>View</div>
                </div>

                <!-- Enable User Action -->
                <div
                  v-if="body.isEnabled === false && isAdmin === true"
                  class="options-menu-item"
                  @click="$emit('enableHandler', body.id)"
                >
                  <img class="dark" src="../../assets/images/edit-dark.svg" alt="edit icon" />
                  <img class="light" src="../../assets/images/edit-light.svg" alt="edit icon" />
                  <div>Enable</div>
                </div>

                <!-- Disable User Action -->
                <div
                  v-if=" body.isEnabled === true && isAdmin === true"
                  class="options-menu-item"
                  @click="$emit('disableHandler', body.id)"
                >
                  <img class="dark" src="../../assets/images/edit-dark.svg" alt="edit icon" />
                  <img class="light" src="../../assets/images/edit-light.svg" alt="edit icon" />
                  <div>Disable</div>
                </div>

                <!-- Delete User Action -->
                <div
                  v-if="isAdmin === true && body.showDeleteButton === true"
                  class="options-menu-item"
                  @click="$emit('deleteHandler', body.id)"
                >
                  <img class="dark" src="../../assets/images/delete-dark.svg" alt="delete icon" />
                  <img
                    class="light"
                    src="../../assets/images/delete-light.svg"
                    alt="delete icon"
                  />
                  <div>Delete</div>
                </div>

              </div>
            </div>
          </td>

          <!-- View More button for Admin/Agency Jobs List page -->
          <td v-if="body.viewId">
            <button class="view-more-about-jobs" @click="$emit('viewHandler', body.viewId)">View More</button>
          </td>

        </tr>
      </tbody>

    </table>

    <!-- General Empty State component when no job exists -->
    <EmptyDashboardState
      v-else
      v-bind:desc="jobDesc"
      v-bind:emptyHeading="emptyTitle"
    />

    <!-- Admin/Agency/Business Empty State component to handle cases for only
    applications filter that have no result -->
    <EmptyDashboardState
      v-if="!isApplicant && body.length > 0 && bodyList.length === 0"
      v-bind:desc="'No Search Result Found'"
      v-bind:emptyHeading="emptyTitle"
    />

    <!-- Candidate Empty State component to handle cases for both job or
    application filters that have no result -->
    <EmptyDashboardState
      v-if="isApplicant && body.length > 0 && bodyList.length === 0"
      v-bind:desc="'No Search Result Found'"
      v-bind:emptyHeading="emptyTitle"
    />

  </div>
</template>

<script>
import EmptyDashboardState from '../EmptyDashboardState.vue';

export default {
  name: 'ListTable',
  props: [
    'headList',
    'bodyList',
    'emptyStateTitle',
    'emptyListDescription'
  ],
  components: {EmptyDashboardState},
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: this.headList,
      body: this.bodyList,
      emptyTitle: this.emptyStateTitle,
      jobDesc: this.emptyListDescription,
      showOptions: null,
    };
  },
  methods: {
    onCellClick(id) {
      if (!id) return;
      this.$emit('viewHandler', id);
    },
    viewMore(id) {
      let element = document.getElementById(id);
      element.classList.toggle('showView');
    },
    // closeView() {
    //   this.viewMore ? (this.viewMore = false) : null;
    // },
    openMenuOptions(id) {
      id !== this.showOptions ?
      this.showOptions = id : this.closeMenuOptions();
    },
    closeMenuOptions() {
      this.showOptions = null;
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.userData.userType === 'admin' ?
      true : false;
    },
    isApplicant() {
      return this.$store.state.userData.userType === 'normal-user' ?
      true : false;
    }
  }
};
</script>
<style scoped>
  .job-list-table {
    overflow: auto;
  }
  table {
    width: 100%;
  }
  .job-list-table .header {
    background: rgba(27, 36, 72, 0.04);
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    box-sizing: border-box;
  }
  .job-list-table .header th {
    font-family: "montserrat";
    text-align: left;
    font-style: normal;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.375rem;
    color: rgba(27, 36, 72, 0.57);
    padding: 25px 15px;
  }
  .job-list-table .body td {
    font-family: "montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 0.85rem;
    line-height: 1.375rem;
    border-bottom: 0.5px solid #c9c9c9;
    padding: 30px 15px;
    text-transform: capitalize;
  }
  .job-list-table .header th:first-of-type,
  .job-list-table .body td:first-of-type {
    padding-left: 30px;
  }
  .addGreen {
    color: #27AE60;
  }
  .addRed {
    color: #DF2029;
  }
  .addBlue {
    color: var(--colorSecondary);
  }
  .addYellow {
    color: #FFB300;
  }
  .addRed,
  .addGreen,
  .addBlue,
  .addYellow {
    font-family: "montserrat";
    font-size: 1.125rem;
    padding: 20px;
  }
  .view-more-container {
    position: relative;
    display: none;
  }
  .showView {
    display: block;
  }
  .lower-case-class {
    text-transform: lowercase;
  }
  .options-button-container {
    position: relative;
    width: 40px;
    /* height: 40px; */
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    margin-right: 40px;
  }
  .options-menu {
    background: var(--white);
    position: absolute;
    right: 40px;
    width: 190px;
    box-shadow: 0px 8px 11px rgba(43, 61, 110, 0.07);
    border-radius: 5px;
    border: solid 1px #c9c9c959;
    bottom: -25px;
  }
  .hide-options {
    display: none;
  }
  .show-options-container .options-menu {
    display: block;
  }
  .options-menu-item {
    cursor: pointer;
    width: 100%;
    align-items: center;
    display: flex;
    padding: 12px;
    font-size: 14px;
    border-bottom: 1.5px solid #c9c9c959;
  }
  .options-menu-item:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .options-menu-item:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .options-menu-item:hover {
    width: 100%;
    align-items: center;
    display: flex;
    padding: 12px;
    background: var(--colorPrimary);
    color: var(--white);
  }
  .options-menu-item .light {
    display: none;
  }
  .options-menu-item:hover .dark {
    display: none;
  }
  .options-menu-item:hover .light {
    display: block;
  }
  .options-menu-item img {
    width: 14px;
    margin-right: 14px;
  }
  .image-container {
    width: 25px;
  }
  .options-button img {
    width: 20px;
    height: 20px;
    object-fit: cover;
  }
  .view-more-about-jobs {
    background: var(--colorPrimary);
    color: var(--white);
    width: 118px;
    height: 39px;
    border-radius: 20px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-pointer:hover {
    background-color: rgba(2, 95, 160, 0.15);
  }
</style>
